import { Component, OnInit, Input } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { CaseService } from '../../../../shared/services/case.service';
import { CorrespondenceTimelineService } from '../../../../shared/services/correspondence-timeline.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalService } from 'src/app/shared/services/modal.service';
import { YesNoPopupComponent } from 'src/app/shared/components/yes-no-popup/yes-no-popup.component';

@Component({
  selector: 'app-add-case-notes',
  templateUrl: './add-case-notes.component.html',
  styleUrls: ['./add-case-notes.component.scss']
})
export class AddCaseNotesComponent implements OnInit {

  @Input() caseId: number;
  @Input() caseNoteId: number;

  isLoading: boolean = false;

  editMode: boolean = false;

  notesForm = new UntypedFormGroup({
    caseNoteText: new UntypedFormControl()
  });

  showOnPortal1: boolean = true;

  constructor(
  public activeModal: NgbActiveModal,
  public modalService: ModalService,
  private caseService: CaseService,
  private correspondenceTimelineService: CorrespondenceTimelineService) {

  }

  ngOnInit(): void {
     if(this.caseNoteId){

      this.editMode = true;
      this.caseService.getCaseNote(this.caseId, this.caseNoteId).subscribe(result => {
        this.notesForm.controls["caseNoteText"].patchValue(result.caseNote.notes);
        this.showOnPortal1 = !result.caseNote.internalNote;
      });
    }
  }

  saveNotes(){

    this.isLoading = true;

    
      const modalRef = this.modalService.openWithOptions(YesNoPopupComponent, {size: 'lg'});
      
      modalRef.componentInstance.messageHeader = 'Is this very important information required in the Case Overview Screen?';
      modalRef.componentInstance.popupText1 = '';
      modalRef.componentInstance.popupText2 = '';

      modalRef.result.then(
        (result) => {
          var addToOverview = result === true;

          let newNote = {
            caseNoteText: this.notesForm.controls['caseNoteText'].value,
            internalNote: !this.showOnPortal1,
            addToOverview: addToOverview
          };

          this.caseService.addCaseNote(this.caseId, newNote).subscribe((response: any) => {
            this.correspondenceTimelineService.refreshCaseTimeline.next();
            this.activeModal.close(true);
          }, (error: any) => {
            var errorMessage = "Failed to add case note";
            if (error.error !== null && error.error.message !== undefined) {
              errorMessage = error.error.message;
            }
            this.isLoading = false;
          });
        },
        () => {
          // User clicked No or dismissed
          this.isLoading = false;
        }
      );
  }

  toggle(checkboxVal: boolean){
    this.showOnPortal1 = checkboxVal;
  }

  cancel(){
    this.activeModal.dismiss();
  }

  updateCaseNote(){
    let note = {
      caseNoteText : this.notesForm.controls['caseNoteText'].value,
      internalNote : !this.showOnPortal1
    };

    this.caseService.updateCaseNote(this.caseId, this.caseNoteId, note).subscribe((response : any) => {

      this.correspondenceTimelineService.refreshCaseTimeline.next();
      this.activeModal.close(true);

      }, (error : any) => {

        var errorMessage = "Failed to update case note";
        if(error.error !== null && error.error.message !== undefined)
        {
          errorMessage = error.error.message;
        }

      });


  }

}
